import React, { Component } from "react";
import {useLocation, useParams, useSearchParams } from "react-router-dom";
import { CallAPI, GetCookieFunction, RemoveCookieFunction, HandleTextChange, HandleCheckChange, BirthdayToAge } from '../../utils/util';
import { GetTzAwareTime } from '../../utils/util';
import { PatientOptions } from './patientOptions'

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

// Query params:
// checkedIn: true/false (optional, default: false)
class PatientLookup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            "rows": [],
            "searchTerm": "",
            "checkedIn": false,
            "inTreatmentOnly": false
        };
        RemoveCookieFunction("Patient_ID");
        RemoveCookieFunction("Patient_Info");

        this.getRows = this.getRows.bind(this);
        this.handleTextChange = HandleTextChange.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);

        this.state.checkedIn = (this.props.router.searchParams.get('checkedIn') === "true" || this.props.router.searchParams.get('checkedin') === "true") ? true : false;
        this.state.inTreatmentOnly = (this.props.router.searchParams.get('inTreatment') === "true" || this.props.router.searchParams.get('intreatment') === "true") ? true : false;
    };

    componentDidMount() {
        const checkedInParam = (this.state.checkedIn || this.state.inTreatmentOnly) ? 1 : -1;
        const centerId = GetCookieFunction("Center").id;
        CallAPI({}, `patients/lookup?checkedin=${checkedInParam}&centerid=${centerId}&limit=10`, 'GET', (res) => {
            this.setState({rows: res});
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const checkedInParam = (this.state.checkedIn || this.state.inTreatmentOnly) ? 1 : -1;
        const centerId = GetCookieFunction("Center").id;
        CallAPI({}, `patients/lookup?search=${encodeURIComponent(this.state.searchTerm??"")}&checkedin=${checkedInParam}&centerid=${centerId}&limit=10`, 'GET', (res) => {
            this.setState({rows: res});
        });
    }

    getFilteredRows() {
        let rows = this.state.rows;
        if (this.state.inTreatmentOnly) {
            rows = rows.filter(r => r.dialysisStarted);
        }
        return rows;
    }

    getRows() {
        if (this.state.rows.length === 0){
            return (
                <tr><td className="tableText"><b>No patient records found.</b></td></tr>
            )
        }

        var i = 0
        //const currentContext = this;
        return this.state.rows.map(function(rows) {
            i++;
            console.log(rows)
            return(
                <tr key={i}>
                    <td>
                        <div className="patient-lookup-table-row">
                            <div className="patient-lookup-info">
                                <b>{rows.firstName} {rows.lastName}</b>
                                <br/>
                                <span><b>Age: {BirthdayToAge(rows.birthDay, rows.age)}</b></span>
                                { rows.checkedIn ? (
                                    <span>
                                        <br/>Check-in: {rows.checkinTime ? GetTzAwareTime(rows.checkinTime, GetCookieFunction("User").tz) : ""}
                                        <br/>Check-in Duration: {rows.checkinDuration} minutes
                                    </span>
                                ) : (
                                    <></>
                                )}
                                { rows.dialysisStarted ? (
                                    <span>
                                        <br/>Dialysis Start: {GetTzAwareTime(rows.treatmentStartTime, GetCookieFunction("User").tz)}
                                        <br/>Remaining Time: {rows.prescribedDuration - rows.treatmentDuration} minutes
                                        { (rows.timeSinceLastCheckin != null) ? (
                                            <>
                                                <br/>Time Since Last Follow-Up: {rows.timeSinceFollowUp} minutes
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </span>
                                ) : (
                                   <></>
                                )}
                            </div>
                            <div className="patient-lookup-table-row-toolbar">
                                <PatientOptions patientId={rows.patientID} checkedIn={rows.checkedIn} dialysisStarted={rows.dialysisStarted} ></PatientOptions>
                            </div>
                        </div>
                    </td>
                </tr>
            );
        })
    };

    render = () => {
        return(
            <div className="lookup-page">
                <div className="lookup-filter-bar">
                    <form className="lookup-filter-form" onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="lookup-filter-fields">
                            <div className="lookup-field" style={{flex: 2}}>
                                <label htmlFor="searchTerm">Search</label>
                                <input
                                    type="text"
                                    id="searchTerm"
                                    name="searchTerm"
                                    onChange={(e) => this.handleTextChange(e)}
                                    placeholder="Name or phone number"
                                />
                            </div>
                            <div className="lookup-field lookup-field-check">
                                <label className="lookup-checkbox-label">
                                    <input
                                        type="checkbox"
                                        id="checkedIn"
                                        name="checkedIn"
                                        onChange={(e) => this.handleCheckChange(e)}
                                        checked={this.state.checkedIn}
                                    />
                                    Checked-in only
                                </label>
                            </div>
                            <div className="lookup-field lookup-field-check">
                                <label className="lookup-checkbox-label">
                                    <input
                                        type="checkbox"
                                        id="inTreatmentOnly"
                                        name="inTreatmentOnly"
                                        onChange={(e) => this.handleCheckChange(e)}
                                        checked={this.state.inTreatmentOnly}
                                    />
                                    In treatment only
                                </label>
                            </div>
                            <div className="lookup-field lookup-field-btn">
                                <button type="submit" className="logSubmit lookup-search-btn">Search</button>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="lookup-results">
                    <div className="lookup-results-header">
                        <span>Patient Information</span>
                        <span className="lookup-count">{this.getFilteredRows().length} result{this.getFilteredRows().length !== 1 ? 's' : ''}</span>
                    </div>
                    <div className="lookup-results-body">
                        {this.getFilteredRows().length === 0
                            ? <div className="lookup-empty">No patient records found.</div>
                            : this.getFilteredRows().map((row, i) => (
                                <div key={i} className="lookup-row">
                                    <div className="lookup-row-info">
                                        <a href={`/patients/${row.patientID}/profile`} className="lookup-row-name">
                                            <strong>{row.firstName} {row.lastName}</strong>
                                            {row.patientCode && <span style={{fontWeight:'normal', fontSize:'13px', color:'var(--text-muted)', marginLeft:'8px'}}>{row.patientCode}</span>}
                                        </a>
                                        <span>Age: {BirthdayToAge(row.birthDay, row.age)}</span>
                                        {row.checkedIn && (
                                            <span>
                                                Check-in: {row.checkinTime ? GetTzAwareTime(row.checkinTime, GetCookieFunction("User").tz) : "—"}
                                                &nbsp;·&nbsp; {row.checkinDuration} min ago
                                            </span>
                                        )}
                                        {row.dialysisStarted && (
                                            <span>
                                                Dialysis started: {GetTzAwareTime(row.treatmentStartTime, GetCookieFunction("User").tz)}
                                                &nbsp;·&nbsp; {row.prescribedDuration - row.treatmentDuration} min remaining
                                            </span>
                                        )}
                                        <div className="lookup-row-status">
                                            {row.dialysisStarted
                                                ? <span className="badge badge-success">In Treatment</span>
                                                : row.checkedIn
                                                    ? <span className="badge badge-warning">Checked In</span>
                                                    : <span className="badge badge-muted">Not Checked In</span>
                                            }
                                        </div>
                                    </div>
                                    <div className="lookup-row-actions">
                                        <PatientOptions
                                            patientId={row.patientID}
                                            checkedIn={row.checkedIn}
                                            dialysisStarted={row.dialysisStarted}
                                        />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        );
    };
}

export default withRouter(PatientLookup)